module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABYUlEQVQoU22RsUtVYRjGf89JcaxV/4CgQDD02BANUtkUpFNTIHTPkSBIaGhQaAqHXKTBc68hBCougg7lIA3R4v3uFZQaHAxqaWyswb4nrnEuB27f9H3P8/543/d7ROWMN3wT89LwGxggMh9m9bFao/IxWngwERsDZ0x/eqyfo4UvJmI7mpl2ru9lXRcYa/gp5qSV6X1pXi88GWE45FrqAdK656N518512AVWfDUmPAyZnv+vw50kcqOZ60VppoUXLI5amXZ7AGyldd4ivgIfZCYsroQaD8ZWeSY4DTVtd3e49sZDfX94DfQjPity0PzBbjrIkhO+ydwLmW6dAyNrvtR/xk6MzFV3SOte7MAWX4gstjLdPQfShl9h9kKm/co3D0tsAQuCmuFXK9NUCeyHmm5XM7kglm2OLSYE7ozT8f8BhQ8Ry5VEH2HWgcsh11xP0uOF71dFJ6zKbDYzPanqnftfczOLDaXx3r0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/editor.png
// module id = iJOp
// module chunks = 1